
import Util from "@/ts/Util";
import { Component, Vue } from "vue-property-decorator";

@Component({
  props: {
    icon: String,
    content: String,
    contentTop: String,
    description: String,
  },
})
export default class ModalCodigo extends Vue {
  mounted() {
    Util.setBackButtonBehavior(this.close);
  }

  close() {
    let elem = $(".sidenav");
    const self = this;
    Util.setBackButtonBehavior(function () {
      if (elem.length > 0) {
        $(".sidenav").sidenav("close");
      } else {
        self.$router.go(-1);
      }
    });
    this.$emit("close");
  }
}
